import type { RouteRecordRaw } from 'vue-router';

// Права на кожен посібник перевіряє API: `/help` відкритий усім, хто увійшов
// (це запасна посадка «/»), і показує лише посібники, які людина може читати.
export const helpRoute: RouteRecordRaw = {
  path: '/help',
  name: 'Help',
  component: () => import('./pages/HelpIndexPage.vue'),
  meta: {
    layout: 'main',
  },
};

// Без сторінки — перша сторінка посібника; яка вона, знає лише API, тож
// переадресацію робить сама сторінка, коли дістане зміст.
export const helpGuideRoute: RouteRecordRaw = {
  path: '/help/:guideSlug',
  name: 'HelpGuide',
  component: () => import('./pages/HelpGuidePage.vue'),
  props: (route) => ({
    guideSlug: String(route.params['guideSlug']),
  }),
  meta: {
    layout: 'main',
  },
};

export const helpGuidePageRoute: RouteRecordRaw = {
  path: '/help/:guideSlug/:pageSlug',
  name: 'HelpGuidePage',
  component: () => import('./pages/HelpGuidePage.vue'),
  props: (route) => ({
    guideSlug: String(route.params['guideSlug']),
    pageSlug: String(route.params['pageSlug']),
  }),
  meta: {
    layout: 'main',
  },
};
